import * as $ from 'jquery';

import 'bootstrap-sass/assets/javascripts/bootstrap/carousel';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'bootstrap-sass/assets/javascripts/bootstrap/tab';
import 'styles/styles.scss';

import './dependencies/polyfills';
import './dependencies/external-stylesheet-loader';
import './dependencies/anchor-scroll';
import './dependencies/main-layouts';
import './dependencies/naturalize';
import './dependencies/lazysizes';
import './dependencies/marketo';
import './dependencies/search';

window.queryParams = require('./dependencies/query-params');
window.logger = require('./dependencies/logger');

window.$ = window.jQuery = $;
window.$win = $win = $(window);
window.$bod = $bod = $('body');
window.$mainNav = $mainNav = $('#nav-main');
window.docCookies = docCookies = require('./dependencies/cookies');
window.animate = require('./dependencies/animations');
window.pcJourney = require('./dependencies/pc-journey');
window.dataTrackClickHelper = require('./dependencies/data-track-click-helper');

window.addEventListener('load', () => {
  let setAttempts = 0;

  setDataTrackClicks();
  setAnalytics();
  setModals();
  setWistiaEmbeds();
  setStaticNav();
  triggerQueryParams();
  setPlateDynamicPadding();

  const driftLoaded = () => {
    setAttempts++;

    if (typeof window.drift === 'function' && drift.api) {
      window.addEventListener('scroll', driftWidgetAnimation);
      window.addEventListener('scroll', scrollResizeHandler);
      window.addEventListener('resize', scrollResizeHandler);
    } else if (setAttempts <= 5) {
      setTimeout(() => {
        driftLoaded();
      }, 1000);
    }
  };

  $('a[data-lang-selection]').click(function() {
    const cookieName = 'pc_regionOverride';
    docCookies.setCookie(
      cookieName,
      $(this)
        .attr('data-lang-selection')
        .toLowerCase()
        .replace('_', '-')
    );
  });

  driftLoaded();
});

function setModals() {
  $('a[data-modal-target]').click(function() {
    $(`#${$(this).attr('data-modal-target')}`).modal('show');
  });
}

function driftWidgetAnimation() {
  const $driftWidget = document.querySelector('#drift-widget');

  if ($driftWidget) {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    var windowHeight = document.documentElement.clientHeight || window.innerHeight;
    var scrollHeight = document.documentElement.scrollHeight;
    var pageScrollCompletion = Math.floor((scrollPosition / (scrollHeight - windowHeight)) * 100);

    if (pageScrollCompletion === 100) {
      $driftWidget.style.bottom = '130px';
    } else {
      $driftWidget.style.bottom = '24px';
    }
  }
}

function scrollResizeHandler() {
  if ($win.width() >= 992) {
    drift.on('ready', function(api) {
      api.widget.show();
    });
  } else {
    drift.on('ready', function(api) {
      api.widget.hide();
      drift.on('sidebarClose', function(e) {
        if (e.data.widgetVisible) {
          api.widget.hide();
        }
      });
    });
  }
}

function setStaticNav() {
  var lastPosition = 0;

  document.addEventListener('scroll', function() {
    let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    let windowHeight = document.documentElement.clientHeight || window.innerHeight;
    let scrollHeight = document.documentElement.scrollHeight;

    const $nav = document.querySelector('header nav');

    if ($nav) {
      let scrolledFromTop = scrollPosition > $nav.clientHeight;
      let scrolledUp = scrollPosition >= scrollHeight - windowHeight - 100 || lastPosition <= scrollPosition;

      if (scrolledFromTop && scrolledUp) {
        $nav.style.top = -$nav.clientHeight + 'px';
      } else {
        $nav.style.top = 0;
      }
    }

    lastPosition = scrollPosition;
  });
}

function setAnalytics() {
  window._wq = window._wq || [];
  _wq.push({
    id: '_all',
    onReady: function(video) {
      video.bind('wistia-popover', function(event, iframe) {
        iframe.wistiaApi.time(0).play();
        iframe.wistiaApi.bind('end', function() {
          var reportData = {};
          reportData['WistiaVideo'] = 'Wistia video has ended';
          Bizible.Push('Event', reportData);
        });
      });
    }
  });
}

function setWistiaEmbeds() {
  if (document.querySelectorAll('.wistia_embed').length > 0) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    document.body.appendChild(script);
  }
}

function triggerQueryParams() {
  if ('wistiaID' in queryParams || 'video' in queryParams) {
    var wistiaID = queryParams.wistiaID || queryParams.video;

    window._wq = window._wq || [];
    _wq.push({
      id: wistiaID,
      onReady: function(video) {
        if (video.container.className.indexOf('popover=true') != -1) {
          video.popover.show();
          video.play();
        } else {
          video.play();
        }
      }
    });
  }

  if ('source' in queryParams || 'modal' in queryParams) {
    var modalID = queryParams.source || queryParams.modal;

    $(`#${modalID}`).modal();
  }
}

function setDataTrackClicks() {
  dataTrackClickHelper.setDataTrackClicks();
}

function setPlateDynamicPadding() {
  document.querySelectorAll('.plate .psudo-float-upwards').forEach(area => {
    var prevParent = area.parentNode.previousElementSibling;
    var isPlate = prevParent.classList.contains('plate');

    if (isPlate) {
      var prevParentSections = prevParent.querySelectorAll('section');
      var prevParentLastSection = prevParentSections.length ? prevParentSections[prevParentSections.length - 1] : null;
      prevParentLastSection != null ? prevParentLastSection.classList.add('psudo-float-upwards-padding') : null;
    }
  });

  document.querySelectorAll('.plate .psudo-float-downwards').forEach(area => {
    var nextParent = area.parentNode.nextElementSibling;
    var isPlate = nextParent.classList.contains('plate');

    if (isPlate) {
      var nextParentFirstSection = nextParent.querySelectorAll('section')[0] || null;
      nextParentFirstSection != null ? nextParentFirstSection.classList.add('psudo-float-downards-padding') : null;
    }
  });
}

import './legacy/src-main.js';
